import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sidebar } from 'app/components';
import { SIDEBAR_MENU_LIST, TAB_ROUTES } from './constants';
import './style';

const PrimaryAdminPanel = (props) => {
  const { children } = props;

  const [activeSection, setActiveSection] = useState('to-approve');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const idx = Object.values(TAB_ROUTES).findIndex((tabRoute) => tabRoute === location.pathname);

    if (idx > -1 && Object.keys(TAB_ROUTES)[idx] !== activeSection) setActiveSection(Object.keys(TAB_ROUTES)[idx]);
  }, [location?.pathname]);

  const onSelectTab = (value) => {
    navigate(TAB_ROUTES[value]);
    setActiveSection(value);
  };

  return (
    <div className='flex primary-admin-layout overflow-auto mt-[100px]'>
      <Sidebar
        menuItems={SIDEBAR_MENU_LIST}
        onMenuClick={(item) => onSelectTab(item.value)}
        selectedItem={activeSection}
        colorMode="black"
        className="primary-admin-side-panel"
      />
      <div className='flex-1 h-full'>
        {children}
      </div>
    </div>
  );
};

export default PrimaryAdminPanel;
